import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { PrettyTransformPipe } from 'projects/osn-shared/src/lib/pipes/pretty-transform.pipe';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RootAppState } from '../../app.reducer';
import { selectCxbCountries, selectCxbPlatforms, selectCxbUserSegments } from '../../app.selectors';
import { Country } from '../../domain/country';
import { Platform } from '../../domain/platform';
import { UserSegment } from '../../domain/user-segment';

type TargetingType = 'Country' | 'UserSegment' | 'Platform';

const selectorMap = {
  Country: selectCxbCountries,
  UserSegment: selectCxbUserSegments,
  Platform: selectCxbPlatforms,
} as const;

@Pipe({
  name: 'pageListTargetingTooltip',
})
export class PageListTargetingTooltipPipe implements PipeTransform {
  constructor(private readonly rootStore: Store<RootAppState>, private readonly prettyTransformPipe: PrettyTransformPipe) {}

  // eslint-disable-next-line rxjs/finnish
  public transform(value: string[], type: TargetingType): Observable<{ tooltip: string; displayedText: string }> {
    return this.rootStore.select<Array<Country | UserSegment | Platform>>(selectorMap[type]).pipe(
      map((result: Country[] | UserSegment[] | Platform[]) => {
        return {
          tooltip: result.length === value.length ? 'All' : this.prettyTransformPipe.transform(value),
          displayedText: result.length === value.length ? 'All' : this.prettyTransformPipe.transform(value),
        };
      }),
      first()
    );
  }

  private prettyTransformValues(values: string[]): string {
    return values
      .map((it) => {
        const dashRemoved = it.replace('-', ' ');
        return (dashRemoved[0]?.toUpperCase() ?? '') + dashRemoved.substring(1);
      })
      .join(', ');
  }
}
